import React, {Component} from 'react';
import wNumb from 'wnumb';
import Nouislider from "nouislider-react";
import Frames from './frames';

import "./nouislider/nouislider.css";
import './main-area.scss';

const MainPicture = (props) => {
	const {pathimages, srcwebp, srcimg, label} = props;

	const img = pathimages + srcimg,
		  webpimg = pathimages + srcwebp;

	if ( srcwebp === undefined || srcwebp===''){
		return(
			<img src={img} alt={label} id="main-frame-picture" />
		)
	} else {
		return(
			<picture id="main-frame-picture">
				<source srcSet={webpimg} type="image/webp" />
				<img src={img} alt={label} />
			</picture>
		)
	}
}

export default class MainArea extends Component{
	render(){
		const {mainstate, pathimages, onUpdateHeight, onUpdateWidth, typewindowdata, onUpdateWindowsLeaf, windowsTypeLeaf} = this.props;

		const {window_height, window_width, windowNum} = this.props.mainstate;

		const idx = typewindowdata.findIndex((el) => el.id === mainstate.currentTypeWindowId);
		const {id, xmin, xmax, ymin, ymax, label, bigImgFile, bigImgWebpFile } = typewindowdata[idx];

		const initialClassName = `wincalc-construction wincalc-construction-${id}`;

		return (
			<div className='wincalc-main d-flex justify-content-center'>
				<div className='wincalc-vertical-slider'>
					<Nouislider
						id="vertical-slider"
						start={window_height}
						step={10}
						range={{ min: ymin, max: ymax }}
						orientation="vertical"
						direction="rtl"
						behaviour="tap-drag"
						tooltips
						format={ wNumb({ decimals: 0 }) }
						pips={{
							mode: 'range',
							density: 2,
							stepped: false
						}}
						onUpdate={ (render, handle, value, un, percent) => {
							document.querySelector('#wincalc-size-y').value = Number(value[0].toFixed(0));
						}}
						onChange={ (render, handle, value, un, percent) => {
							onUpdateHeight(Number(value[0].toFixed(0)));
						}}
					/>
				</div>

				<div className='wincalc-main-window-container'>
					<div className={initialClassName}>
						<MainPicture
							srcwebp={bigImgWebpFile}
							srcimg={bigImgFile}
							label={label}
							pathimages={pathimages}
						/>

						<Frames
							onUpdateWindowsLeaf = {onUpdateWindowsLeaf}
							windowstypeleaf = {mainstate.windowsTypeLeaf}
							typewindowdata = {typewindowdata}
							windownum = {windowNum}
							pathimages={pathimages}
						/>
					</div>

					<div className='wincalc-horizontal-slider'>
						<Nouislider
							id="horizontal-slider"
							start={window_width}
							step={10}
							range={{ min: xmin, max: xmax }}
							behaviour="tap-drag"
							tooltips
							format={ wNumb({ decimals: 0 }) }
							pips={{
								mode: 'range',
								density: 2,
								stepped: false
							}}
							onUpdate={ (render, handle, value, un, percent) => {
								document.querySelector('#wincalc-size-x').value = Number(value[0].toFixed())
							}}
							onChange={ (render, handle, value, un, percent) => {
								onUpdateWidth(Number(value[0].toFixed()));
							}}
						/>
					</div>
				</div>
			</div>
		)
	}
}